module.exports = __webpack_public_path__ + "assets/img/30_786_big.fd4d999d.jpg";